import { useAccountRepository } from '@frontend/repository';
import { SlotClient } from '@frontend/slot/api';
import { Slot } from '@frontend/slot/types';
import { SpotClient } from '@frontend/spot/api';
import { Spot } from '@frontend/spot/types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useAppDispatch } from '../../../../redux/store';

export const useLayoutRender = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { spotId } = useParams();
    const [spot, setSpot] = useState<Spot | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [slots, setSlots] = useState<Slot[] | null>(null);

    async function fetchSlots(accum: Slot[] = [], offset: number = 0) {
        if (!spotId) return;
        const res = await SlotClient.fetchSlots({ account_id: currentAccount, spot_id: spotId, size: '1000', offset });
        const newAccum = [...accum, ...res.results];
        if (newAccum.length < res.count) {
            await fetchSlots(newAccum, newAccum.length);
        } else {
            setSlots(newAccum);
        }
    }

    useEffect(() => {
        if (!spotId) return;
        async function fetch() {
            await SpotClient.fetchSpot(currentAccount, spotId!).then(setSpot);
            await fetchSlots(slots || []);
        }
        fetch().finally(() => setIsLoading(false));
    }, [currentAccount, spotId]);

    return {
        currentAccount,
        dispatch,
        spot,
        isLoading,
        slots,
        navigate,
        location
    };
};
